
<template>
  <div>
    <chc-loader ref="loader"></chc-loader>
    <chc-modal ref="addTowingCompanyModal" title="Add New Towing Company">
      <div slot="body">
        <towingCompany-add
          v-on:refresh="refresh"
          v-on:close="addTowingCompanyHide">
          ></towingCompany-add>
      </div>
    </chc-modal>
    <datatable
        :source="towingCompanys"
        :isLoading="isLoading"
      >
      <datatable-column
        v-for='(column, index) in columns'
        :id='column.id'
        :label='column.label'
        :key='index'
        >
      </datatable-column>

      <template slot="searchLeft">
        <a class="secondary-action" v-on:click="addTowingCompany">+ Add Towing Company</a>
      </template>

      <template slot="source_template" slot-scope="data">
          <tr @click="gotoRow(data.row.id)">
              <td>{{ data.row.name }}</td>
              <td>{{ data.row.address }}</td>
              <td>{{ data.row.state }}</td>
              <td>{{ data.row.phone }}</td>
          </tr>
      </template>
    </datatable>
  </div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import TowingCompanyAdd from '@/components/TowingCompany/TowingCompanyAdd'
import store from '@/store'

export default {
  name: 'TowingCompanysSummary',
  mounted () {
    this.refresh()
  },
  data () {
    return {
      columns: [
        { id: 'name', label: 'Towing Company Name' },
        { id: 'address', label: 'Address' },
        { id: 'state', label: 'State' },
        { id: 'phone', label: 'Phone' }
      ],
      isLoading: true,
      towingCompanys: []
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    TowingCompanyAdd
  },
  methods: {
    gotoRow (rowId) {
      this.$refs.loader.show()
      this.$router.push({name: 'TowingCompany', params: {towingCompanyId: rowId}}, () => {
        this.$refs.loader.hide()
      })
    },
    addTowingCompany () {
      this.$refs.addTowingCompanyModal.show()
    },
    addTowingCompanyHide () {
      this.$refs.addTowingCompanyModal.hide()
    },
    refresh () {
      Promise.all([
        store.dispatch('syncConstants'),
        store.dispatch('syncSummary'),
        store.functions.towingCompanies.towingCompaniesTable((response) => { this.towingCompanys = response.data })
      ]).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TowingCompany/TowingCompanysSummary.vue